export default "__VITE_ASSET__BhfpCy91__"